import templateUrl from 'emun.report/report-list.htm'
import controller from 'emun.report/report-list.controller'

let ReportList = {
    bindings: {
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default ReportList;